import React from 'react';
import moment from 'moment';
// Basic Components
import CardSimple from 'screens/components/basic/CardSimple';
// Child Components
import DataGrid from './DataGrid';
import DataChart from './DataChart';

const Body = ({ startDate, endDate, agGridRef }) => {
    return (
        <CardSimple>
            <div className="text-center list_header mb-2">
                {startDate && endDate ?
                    <p><i>Date Range:</i> <b>{moment(startDate).format('MMMM Do, YYYY')} - {moment(endDate).format('MMMM Do, YYYY')}</b></p>
                    : ""}
            </div>
            <DataGrid agGridRef={agGridRef} />
            <DataChart />
        </CardSimple>
    )
}

export default Body;